
const mappa = {
  'Complesso di fondi / Superfondo': 'fa-sitemap',
  'Complesso di fondi   Superfondo': 'fa-sitemap',
  'Fondo': 'fa-archive',
  'Subfondo': 'fa-inbox',
  'Collezione / Raccolta': 'fa-th',
  'Collezione   Raccolta': 'fa-th',
  'Serie': 'fa-bars',
  'Fascicolo': 'fa-folder',
  'Sottofascicolo': 'fa-folder-o',
  'Inserto': 'fa-files-o',
  'Documento': 'fa-file-o',
  'Audiovideo': 'fa-video-camera',
  'Bibliografia': 'fa-book',
  'Corrispondenza': 'fa-envelope-open-o',
  'Delibera': 'fa-fax',
  'Fotografia': 'fa-camera-retro',
  'Iconografica': 'fa-file-image-o',
  'Manoscritto': 'fa-file-text-o',
  'Oggetto': 'fa-cube',
  'Verbale': 'fa-bandcamp',
  'Cartolina': 'fa-map',
  'Cartografia': 'fa-picture-o'
}

module.exports = {
  getIcon (type) {
    return mappa[type] || 'fa-file'
  }
}



// WEBPACK FOOTER //
// ./src/js/components/hierarchytree/hierarchyIcons.js